/** Слияние двух массивов (parentArr & childArr)
 * с слиянием объектов внутри них, у которых совпадает значение param
 * @param {array} parentArr - слияемый массив (куда)
 * @param {array} childArr - сливаемый массив (что)
 * @param {string} param - параметр, по которому происходит сравнение
 * (если в двух массивах совпадает это значение, массивы сливаются в один)
 */
export const mergeArrayObjectsByParam = (parentArr = [], childArr = [], param) => {
  if (parentArr && childArr && param) {
    return parentArr.reduce((acc, cur) => {
      const findItem = childArr
        .find(item => JSON.stringify(item[param]) === JSON.stringify(cur[param]));

      if (findItem) {
        acc.push({ ...cur, ...findItem });
      } else {
        acc.push(cur);
      }

      return acc;
    }, []);
  }

  return [...parentArr, ...childArr];
};

/** Рекурсивный обход массива с раскладыванием дочерних элементов
 * в родительские (при совпадении id и parent параметров)
 * @param {array} arr - массив с данными
 * @param {array} openedSlugsArr - массив с slug,
 * по которым определяется состояние вкладок (закрыта/открыта)
*/
export const collectArrayByHierarchy = (arr = [], openedSlugsArr = []) => {
  // Не работать с пустыми и одиночными входными массивами
  if (arr?.length <= 1) {
    return arr;
  }

  // Проход по одной вложенности массива
  const result = arr?.reduce((acc, cur) => {
    const findAcc = acc.data.find(item => item?.id === cur?.parent);

    // Если slug элемента совпадает с одним из переданных в openedSlugsArr значением,
    // помечать элемент как вкладку с раскрытым состоянием
    if (openedSlugsArr.length) {
      const activeDoc = cur.documents.find(doc => openedSlugsArr.includes(doc.slug));

      cur.isOpened = !!activeDoc;
    }

    if (!findAcc?.length) {
      // Получить только вложенные в текущий элементы
      // и отфильтровать элементы без дочерних документов
      const findChildren = arr
        .filter(item => item?.parent === cur?.id)
        .filter(item => item?.documents?.length);

      if (findChildren?.length) {
        // Если один из детей - это раскрытый коллапс-блок,
        // то и родитель тоже должен быть раскрыт
        const formattedChildren = findChildren.map((item) => {
          if (item?.children) {
            return {
              ...item,
              isOpened: !item?.isOpened
                ? !!item.children.find(children => children.isOpened)
                : item?.isOpened,
            };
          }

          return item;
        });

        // При наличии в аккумулируемом массиве такого же элемента,
        // обновить новособранный (с отфильтрованными детьми) путем слияния двух массивов
        acc.data.push({
          ...cur,
          children: cur?.children
            ? mergeArrayObjectsByParam(cur.children, formattedChildren, 'id')
            : formattedChildren,
        });

        acc.changedElementsPerLastCycle += 1;
      } else if (cur?.parent === null) {
        acc.data.push(cur);
      }
    }

    return acc;
  }, {
    changedElementsPerLastCycle: 0,
    data: [],
  });

  if (result.changedElementsPerLastCycle > 0) {
    return collectArrayByHierarchy(result.data);
  }

  return result.data;
};
